import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEnsureUser } from "../auth/hooks/useEnsureUser";
import { UserType } from "../models/UserType";
import ClientRoutes from "../routes/ClientRoutes";
import InternalRoutes from "../routes/InternalRoutes";
import FreelanceRoutes from "./FreelancerRoutes";

const AppRoutes: React.FC = () => {
	const { user } = useEnsureUser();
	const location = useLocation();

	useEffect(() => {}, [user.id, user.type, location.pathname]);

	return (
		<Routes>
			{user.type === UserType.Freelancer && (
				<Route key="freelancer-routes" path="/*" element={<FreelanceRoutes />} />
			)}
			{user.type === UserType.Internal && (
				<Route key="internal-routes" path="/*" element={<InternalRoutes />} />
			)}
			{user.type === UserType.Client && (
				<Route key="client-routes" path="/*" element={<ClientRoutes />} />
			)}

			<Route key="default-redirect" path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
};

export default AppRoutes;
